import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchMouleSelectionPromotion } from "../AirlineImages/FetchModule";

export const getCentralisedPromotionsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  centralizedPromotions: [
    {
      fieldName: "Banner",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner",
      placeholder: "Select Banner",
      validation: { required: "Banner is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionPromotion,
    },
    // {
    //   fieldName: "Banner Body Image",
    //   fieldValue: "banner_body_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "banner_body_image",
    //   formType: "file",
    //   usedFileType: "image/*",
    //   label: "Banner Body Image",
    //   placeholder: "Select Banner Body Image",
    //   validation: { required: "Banner Body Image is required" },
    // },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Redirect URL",
      fieldValue: "redirect_url",
      className: "col-span-6",
      type: "text",
      name: "redirect_url",
      formType: "input",
      label: "Redirect URL",
      placeholder: "Enter Redirect URL",
      note: "The Redirect URL field is applicable only for Passenger",
      validation: {
        validate: (value: any): true | string => {
          if (!value || value === "" || typeof value !== "string") {
            return true;
          }
          const url = value.trim();
          const isInternal = url.startsWith("/");
          const isExternal = /^https?:\/\//i.test(url) || /^www\./i.test(url);
          return isInternal || isExternal ? true : "Please enter a valid URL (start with / or https://, http://, www.)";
        },
      },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description_english_1",
      className: "col-span-6",
      type: "text",
      name: "description_english_1",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_malay_1",
      className: "col-span-6",
      type: "text",
      name: "description_malay_1",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_1",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Terms and Condition (EN)",
      fieldValue: "terms_condition",
      className: "col-span-6",
      type: "text",
      name: "terms_condition",
      formType: "richText",
      label: "Terms and Condition (EN)",
      placeholder: "Enter Terms and Condition (EN)",
      // validation: { required: "Terms and Condition (EN) is required" },
    },
    {
      fieldName: "Terms and Condition (MS)",
      fieldValue: "terms_condition_malay",
      className: "col-span-6",
      type: "text",
      name: "terms_condition_malay",
      formType: "richText",
      label: "Terms and Condition (MS)",
      placeholder: "Enter Terms and Condition (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Terms and Condition (ZH)",
      fieldValue: "terms_condition_mandarin",
      className: "col-span-6",
      type: "text",
      name: "terms_condition_mandarin",
      formType: "richText",
      label: "Terms and Condition (ZH)",
      placeholder: "Enter Terms and Condition (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Published From",
      fieldValue: "start_date",
      className: "col-span-6",
      type: "dateTime",
      name: "start_date",
      formType: "dateTime",
      label: "Published From",
      placeholder: "Enter Published From",
      // validation: { required: "Published From is required" },
      validation: {
        validate: (value: string, formValues: any) => {
          const endDate = formValues.end_date;

          // If start date exists but end date is empty
          if (endDate && !value) {
            return "Please enter Start date";
          }

          // If both dates exist, validate order
          if (endDate && value) {
            const start = new Date(endDate).getTime();
            const end = new Date(value).getTime();

            if (start < end) {
              return "Published From should be earlier than Published Until";
            }
          }

          return true;
        },
      },
    },
    {
      fieldName: "Published Until",
      fieldValue: "end_date",
      className: "col-span-6",
      type: "dateTime",
      name: "end_date",
      formType: "dateTime",
      label: "Published Until",
      placeholder: "Enter Published Until",
      // validation: { required: "Published Until is required" },
      validation: {
        validate: (value: string, formValues: any) => {
          const startDate = formValues.start_date;

          // If start date exists but end date is empty
          if (startDate && !value) {
            return "Published Until is required";
          }

          // If both dates exist, validate order
          if (startDate && value) {
            const start = new Date(startDate).getTime();
            const end = new Date(value).getTime();

            if (end < start) {
              return "Published Until cannot be earlier than Published From";
            }
          }

          return true;
        },
      },
    },
    // {
    //   fieldName: "MAGP",
    //   fieldValue: "magp_sync",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "magp_sync",
    //   formType: "checkbox",
    //   label: "MAGP",
    //   placeholder: "Enter MAGP Published",
    //   // validation: { required: "MAGP Publish is required" },
    // },
    // // {
    // //   fieldName: "ERAMAN Published",
    // //   fieldValue: "eraman_sync",
    // //   className: "col-span-12",
    // //   type: "checkbox",
    // //   name: "eraman_sync",
    // //   formType: "checkbox",
    // //   label: "ERAMAN Published",
    // //   placeholder: "Enter ERAMAN Published",
    // //   // validation: { required: "ERAMAN Publish is required" },
    // // },
    // {
    //   fieldName: "ERAMAN KLIA 1",
    //   fieldValue: "eraman_klia1",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_klia1",
    //   formType: "checkbox",
    //   label: "ERAMAN KLIA 1",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN KLIA 2",
    //   fieldValue: "eraman_klia2",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_klia2",
    //   formType: "checkbox",
    //   label: "ERAMAN KLIA 2",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Kuching",
    //   fieldValue: "eraman_kuching",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_kuching",
    //   formType: "checkbox",
    //   label: "ERAMAN Kuching",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Penang",
    //   fieldValue: "eraman_penang",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_penang",
    //   formType: "checkbox",
    //   label: "ERAMAN Penang",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Kota Kinabalu",
    //   fieldValue: "eraman_kota_kinabalu",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_kota_kinabalu",
    //   formType: "checkbox",
    //   label: "ERAMAN Kota Kinabalu",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Langkawi",
    //   fieldValue: "eraman_langkawi",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_langkawi",
    //   formType: "checkbox",
    //   label: "ERAMAN Langkawi",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "CORPORATE",
    //   fieldValue: "corporate_sync",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "corporate_sync",
    //   formType: "checkbox",
    //   label: "CORPORATE",
    //   placeholder: "Enter CORPORATE Published",
    //   // validation: { required: "CORPORATE Publish is required" },
    // },
    // // {
    // //   fieldName: "PASSENGER Published",
    // //   fieldValue: "passenger_sync",
    // //   className: "col-span-12",
    // //   type: "checkbox",
    // //   name: "passenger_sync",
    // //   formType: "checkbox",
    // //   label: "PASSENGER Published",
    // //   placeholder: "Enter PASSENGER Published",
    // //   // validation: { required: "PASSENGER Publish is required" },
    // // },
    // {
    //   fieldName: "PASSENGER KLIA 1",
    //   fieldValue: "passenger_klia1",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_klia1",
    //   formType: "checkbox",
    //   label: "PASSENGER KLIA 1",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER KLIA 2",
    //   fieldValue: "passenger_klia2",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_klia2",
    //   formType: "checkbox",
    //   label: "PASSENGER KLIA 2",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Kuching",
    //   fieldValue: "passenger_kuching",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_kuching",
    //   formType: "checkbox",
    //   label: "PASSENGER Kuching",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Penang",
    //   fieldValue: "passenger_penang",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_penang",
    //   formType: "checkbox",
    //   label: "PASSENGER Penang",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Kota Kinabalu",
    //   fieldValue: "passenger_kota_kinabalu",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_kota_kinabalu",
    //   formType: "checkbox",
    //   label: "PASSENGER Kota Kinabalu",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Langkawi",
    //   fieldValue: "passenger_langkawi",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "passenger_langkawi",
    //   formType: "checkbox",
    //   label: "PASSENGER Langkawi",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    {
      fieldName: "Sequence No.",
      fieldValue: "sequence",
      className: "col-span-6",
      type: "text",
      name: "sequence",
      formType: "number",
      label: "Sequence No.",
      placeholder: "Enter Sequence No.",
      validation: { required: "Sequence No. is required" },
    },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
};
